export default __webpack_public_path__ + "static/media/cargoIcon.62306b1b.svg";